


























































import { Vue, Component } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
@Component({
  directives: {
    ClickOutside,
  },
})
export default class ExchangeProductSlotPanel extends Vue {}
